import { ParametrageGeneralDac, ParametrageGeneralDacDto } from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';
import { createStore, withProps } from '@ngneat/elf';

export interface DacGeneralParamsStateProps {
  response?: ParametrageGeneralDac;
  createDto: ParametrageGeneralDacDto;
  updateDto: Partial<ParametrageGeneralDacDto>;
  dynaDocsModelSelected?: SelectOption[];
  paramGeneralTypeSelected?: SelectOption;
  sourceSelected?: SelectOption;
  sourceFieldSelected?: SelectOption;
}

export const dacGeneralParamsInitialState: DacGeneralParamsStateProps = {
  response: undefined,
  createDto: {
    dynaDocsModelIds: [],
  },
  updateDto: {},
  dynaDocsModelSelected: [],
  sourceSelected: { name: '', code: undefined },
  sourceFieldSelected: { name: '', code: undefined },
};

export const dacGeneralParamsStateStore = createStore(
  { name: 'dac-general-params-state' },
  withProps<DacGeneralParamsStateProps>({
    ...dacGeneralParamsInitialState,
  })
);
